module.exports = __webpack_public_path__ + "media/images/austrian/offers/digital-voucher-app2x-beef5d29eb2d4ce3f78923fb009ed788.jpg";